import Vue from 'vue';
import Component from 'vue-class-component';
import ProductFilterPanel from '../ProductFilterPanel/ProductFilterPanel.vue'
import ProductQuickAddPanel from '../ProductQuickAddPanel/ProductQuickAddPanel.vue'
import ProductSortPanel from '../ProductSortPanel/ProductSortPanel.vue'
import ProductGrid from '../ProductGrid/ProductGrid'
import ProductTable from '../ProductTable/ProductTable';
import { Prop, Watch, Emit } from 'vue-property-decorator';
import { sProducts, Products, sProductsToProducts, UpdateProductCountEvent } from '@/api/product';
import REQ_URL from '@/consts/req-url';
import { FilterParams } from '@/types/filter';
import isIntoView from '@/api/isIntoView';
import { PagedResponse } from '@/types/response-data';
import { modalParams } from '@/types/state.modal';
import { carryListing, forgetListing, rememberListing, takeCarriedListing } from '@/api/listingCarry';
import { getCategoryTrailById } from '@/api/categories';

@Component({
    name: "ProductListContainer",
    components: {
        ProductFilterPanel,
        ProductQuickAddPanel,
        ProductSortPanel,
        ProductGrid,
        ProductTable,
        ProductListContainer
    },
})
export default class ProductListContainer extends Vue {
    @Prop({ default: '' }) title!: string
    @Prop({ default: 'short' }) viewMode!: 'short' | 'full'
    @Prop({ default: '' }) spec!: string
    @Prop({ default: () => [] }) analogIds!: string[]
    @Prop({ default: () => [] }) exclude!: string[]
    @Prop({ default: '' }) unsecured!: string
    // Category page: the 1C category id the list is limited to
    @Prop({ default: '' }) categoryId!: string
    // Filters and sort brought over from the previous category's list
    carriedListing = this.viewMode === 'full' ? takeCarriedListing() : null
    pageInfoPrev = {
        curr: 1,
        of: 1
    }
    pageInfo = {
        curr: !this.carriedListing && history.state && history.state.viewMode === this.viewMode ? history.state.page : 1,
        of: 1
    }
    loading = true
    showFilterDrawer = false
    showQuickAddDialog = false

    sortBy = this.carriedListing ? this.carriedListing.sortBy
        : history.state && history.state.viewMode === this.viewMode ? history.state.sortBy : 'vend_asc'
    filterParams: FilterParams = this.withCategory(!this.carriedListing && history.state && history.state.viewMode === this.viewMode ? history.state.filterParams : {
        brand: '',
        spec: this.spec,
        search: '',
        analogIds: this.analogIds,
        exclude: this.exclude,
        unsecured: this.unsecured,
        ...(this.carriedListing ? this.carriedListing.filterParams : {})
    })
    viewListMode = ''
    productsPerPage: number | string = 10
    products: Products = []
    error = ''
    get pageVisible() {
        return this.$vuetify.breakpoint.xsOnly ? 6 : 7
    }

    get compViewListMode() {
        return /*this.$vuetify.breakpoint.xsOnly ? 'grid' :*/ this.viewListMode
    }

    get showAnalogsInFullMode(): boolean {
        return this.viewMode === "full" 
            && this.products.length === 1 
            && this.products[0].Наличие === 0
            && !!this.products[0].АналогИД;
    }

    @Watch('viewListMode') onViewListModeChange(val: string) {
        if (this.viewMode !== 'short') localStorage.setItem('productViewListMode', val)
    }

    @Watch('analogIds', { immediate: true, deep: true })
    onAnalogsChange() {
        if(this.analogIds.length > 0) {
            this.$set(this.filterParams, 'analogIds', this.analogIds);
            this.$set(this.filterParams, 'exclude', this.exclude);
            this.filtering(false, false, false);
        }
    }

    @Emit('fullInit') emitFullInit() {
        return true
    }
    async filtering(needScroll = false, needEmit = false, enablePush = true) {
        this.loading = true
        if (this.viewMode === 'full') rememberListing(this, this.filterParams, this.sortBy)
        window.removeEventListener('scroll', this.onInfiniteScroll)

        try {
            let body = {
                filterParams: this.filterParams,
                page: this.viewMode === 'short' ? void 0 : this.pageInfo.curr,
                sortBy: this.sortBy,
                perPage: this.productsPerPage === 'all' ? 50 : this.productsPerPage,
                viewMode: this.viewMode
            }
            if (this.viewMode === 'full' && enablePush) {
                if (history.state && history.state.viewMode === 'full')
                    history.pushState(body, '', this.$route.path)
                else
                    history.replaceState(body, '', this.$route.path)
            }

            let data = await this.$fetch<PagedResponse<sProducts>>(REQ_URL.GET_PRODUCTS, {
                method: 'POST',
                body: JSON.stringify(body)
            })

            if (data.body) {
                if (this.productsPerPage === 'all' && this.pageInfo.curr !== 1) this.products.push(...sProductsToProducts(data.body.pageContent))
                else
                    this.products = sProductsToProducts(data.body.pageContent)
                if (data.body.pageInfo) {
                    this.pageInfoPrev.curr = this.pageInfo.curr = data.body.pageInfo.curr
                    this.pageInfoPrev.of = this.pageInfo.of = data.body.pageInfo.of
                }
                else this.pageInfo.curr = this.pageInfo.of = 1

                if (needScroll) {
                    this.$nextTick(() => {
                        let tb = document.getElementById('toolbar')
                        if (tb && !isIntoView('#catalog')) {
                            this.$vuetify.goTo('#catalog', {
                                duration: 300,
                                offset: (tb && tb.offsetHeight ? tb.offsetHeight : 0) + 20,
                                //easing: this.easing
                            })
                        }
                    });
                }

                if (this.pageInfoPrev.curr !== this.pageInfoPrev.of && this.productsPerPage === 'all')
                    this.$nextTick(() => window.addEventListener('scroll', this.onInfiniteScroll));

                if (needEmit) this.emitFullInit();
            }
            else throw new Error(data.error ? data.error : 'Ошибка соединения. Повторите позже.')
        } catch (error) {
            this.pageInfo.curr = this.pageInfoPrev.curr
            this.pageInfo.of = this.pageInfoPrev.of

            let errMsg: modalParams = {
                type: 'error',
                msg: error.message
            }
            this.$store.commit('modal:open', errMsg)
        }
        this.loading = false
    }
    async deleteAllUnsecured(){
        this.loading = true
        try {
            let body = {
                c1code: this.unsecured,
            }

            let data = await this.$fetch(REQ_URL.DELETE_ALL_UNSECURED, {
                method: 'DELETE',
                body: JSON.stringify(body)
            })
            if (data.body) {
                this.filtering()
            }
            else throw new Error(data.error ? data.error : 'Ошибка соединения. Повторите позже.')
        } catch (error) {
            let errMsg: modalParams = {
                type: 'error',
                msg: error.message
            }
            this.$store.commit('modal:open', errMsg)
        }
    }
    async deleteItemUnsecured(id: string){
        this.loading = true
        try {
            let body = {
                c1code: this.unsecured,
                id: id
            }

            let data = await this.$fetch(REQ_URL.DELETE_ITEM_UNSECURED, {
                method: 'DELETE',
                body: JSON.stringify(body)
            })
            if (data.body) {
                this.filtering()
            }
            else throw new Error(data.error ? data.error : 'Ошибка соединения. Повторите позже.')
        } catch (error) {
            let errMsg: modalParams = {
                type: 'error',
                msg: error.message
            }
            this.$store.commit('modal:open', errMsg)
        }
    }
    deleteUnsecuredItem(e: string) {
        this.deleteItemUnsecured(e)
    }
    updateProductCount(e: UpdateProductCountEvent) {
        let ind = this.products.findIndex((product) => product.Артикул === e.vCode)
        if (ind !== -1) this.products[ind].quantity = e.count
    }
    updateFilterParams(e: FilterParams) {
        // A category page shows one category: picking another one in the
        // filter opens its page (clearing it, the full list), keeping the
        // other filters and the sort
        if (this.categoryId && (e.categoryId || '') !== this.categoryId) {
            const trail = e.categoryId ? getCategoryTrailById(e.categoryId) : undefined
            if (e.categoryId && !trail) return
            rememberListing(this, e, this.sortBy)
            carryListing()
            this.$router.push(trail ? trail[trail.length - 1].href : '/')
            return
        }
        this.filterParams = this.withCategory(e)
        this.pageInfo.curr = 1
        this.filtering()
    }
    updateSortBy(e: string) {
        this.sortBy = e
        this.filtering()
    }
    updatePage(e: number) {
        this.pageInfo.curr = e;
        this.filtering(true)
    }
    onInfiniteScroll() {
        let productList = this.$refs.productList as HTMLElement | undefined
        // компонент уже уничтожен (ушли из каталога), а обработчик scroll ещё висит на window
        if (!productList) {
            window.removeEventListener('scroll', this.onInfiniteScroll)
            return
        }
        let intersectBottom = productList.getBoundingClientRect().top + productList.clientHeight - window.innerHeight <= 0
        if (intersectBottom) {
            window.removeEventListener('scroll', this.onInfiniteScroll)
            this.infiniteNextPage()
        }
    }
    infiniteNextPage() {
        this.pageInfo.curr++
        this.filtering()
    }
    updateProductsPerPage(val: number | string, needScroll: boolean = false) {
        this.productsPerPage = val

        this.pageInfo.curr = 1
        localStorage.setItem('productsPerPage', this.productsPerPage + '')
        this.filtering(needScroll)
    }
    subsribePopState() {
        if (!history.state || !history.state.viewMode) return;
        this.pageInfo.curr = history.state.page
        this.sortBy = history.state.sortBy
        this.filterParams = this.withCategory(history.state.filterParams)
        this.filtering(false, false, false)
    }
    // On a category page the category comes from the route, not from saved
    // history state or the filter panel
    withCategory(params: FilterParams): FilterParams {
        return this.categoryId ? { ...params, categoryId: this.categoryId } : params
    }
    subsribePopStateBind = () => this.subsribePopState()
    created() {
        this.onInfiniteScroll = this.onInfiniteScroll.bind(this)

        if (this.viewMode === 'full') {
            window.addEventListener('popstate', this.subsribePopStateBind)
        }
        this.viewListMode = this.viewMode === 'short' ? 'grid' :
            localStorage.getItem('productViewListMode') !== null ? localStorage.getItem('productViewListMode') as string :
                this.$vuetify.breakpoint.xsOnly ? 'grid' : 'list'
        localStorage.getItem('productsPerPage') !== null ?
            isNaN(parseInt(localStorage.getItem('productsPerPage') + '')) ? localStorage.getItem('productsPerPage') as string : parseInt(localStorage.getItem('productsPerPage') + '')
            : 10
        this.productsPerPage = this.viewMode === 'short' ? 4 :
            localStorage.getItem('productsPerPage') !== null ?
                isNaN(parseInt(localStorage.getItem('productsPerPage') + '')) ? localStorage.getItem('productsPerPage') as string : parseInt(localStorage.getItem('productsPerPage') + '')
                : 10

        
        if (this.$route.query.search && typeof this.$route.query.search === 'string') {
            this.filterParams.search = this.$route.query.search
        }

        this.filtering(false, true, !(history.state && history.state.viewMode))
    }
    beforeDestroy() {
        forgetListing(this)
        window.removeEventListener('popstate', this.subsribePopStateBind)
        window.removeEventListener('scroll', this.onInfiniteScroll)
    }
}
